import { render } from "./Emoji.vue?vue&type=template&id=c4b0ee68&scoped=true"
import script from "./Emoji.vue?vue&type=script&lang=ts"
export * from "./Emoji.vue?vue&type=script&lang=ts"

import "./Emoji.vue?vue&type=style&index=0&id=c4b0ee68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c4b0ee68"

export default script